import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Component } from 'react';
import { connect } from 'react-redux';

import DOM from './menu';
import defaultLogo from '../../../assets/images/logo.png';
import * as userActions from '../../../core/user/userActions';

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false,
        };
        this.view = DOM;
    }

    openDrawer = () => {
        this.setState({ menuOpen: true });
    };

    closeDrawer = () => {
        this.setState({ menuOpen: false });
    };

    render() {
        return this.view(this.props);
    }
}

Menu.propTypes = {
    actions: PropTypes.object.isRequired,
    items: PropTypes.array,
    logo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    placement: PropTypes.string,
    width: PropTypes.number,
};

Menu.defaultProps = {
    items: [],
    logo: defaultLogo,
    placement: 'left',
    width: 280,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        user: state.user.user,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...userActions,
            },
            dispatch,
        ),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Menu);
